import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import qp from 'query-parse'
import Cookies from 'js-cookie'
import NavBar from '../components/nav/nav-bar'
import NavOpen from '../components/nav/nav-open'
import CartOpen from '../components/cart/cart-open'
import Footer from '../components/footer'
import VideoPlayer from '../components/video'
import TextModal from '../components/text-modal'
import ScrollMaster from '../components/scroll-master'
import Discount from '../utils/discount'

import '../scss/style.scss'
import cookie from '../utils/cookie.json'

let DISCOUNT = new Discount();

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cookie: cookie.discount_cookie
    };
  }

  componentDidMount() {
    const search = this.props.location.search.slice(1);
    const queryObj = qp.toObject(search);

    if (queryObj.discount === "20OFF") {
      Cookies.get(this.state.cookie) === undefined
        ? Cookies.set(this.state.cookie, true, { expires: 1 })
        : Cookies.get(this.state.cookie);
    }
  }

  render() {
    return (
      <div>
        <Helmet
          title={this.props.data.site.siteMetadata.title}
          meta={[
            {
              name: "description",
              content: "Fitness nutrition for everyday athletes"
            },
            { name: "keywords", content: "fitness, nutrition" }
          ]}
        />
        <NavBar location={this.props.location} />
        <div className="page-content content">{this.props.children()}</div>
        <NavOpen location={this.props.location} />
        <CartOpen location={this.props.location} />
        <VideoPlayer location={this.props.location} />
        <TextModal />
        <Footer location={this.props.location} />
        <ScrollMaster />
      </div>
    );
  }
}

export default Layout;

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js